import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
// import { Auth } from 'aws-amplify';

import { environment } from '@environments/environment';
import { AwsService, UserProfileService } from '__services';
import { HttpService } from '__services/http.service';
import { CookieService } from 'ngx-cookie-service';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private http: HttpService,
    private cookieService: CookieService,
    private userProfileService: UserProfileService,
    private awsService: AwsService,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (request.headers.has('Authorization')) {
      return next.handle(request);
    }

    const localToken = localStorage.getItem('access_token');
    if (localToken) {
      const withAuthRequest = request.clone({
        setHeaders: {
          Authorization: `${environment.providers.api.auth.type} ${localToken}`,
        },
      });
      return next.handle(withAuthRequest);
    }

    return from(this.awsService.fetchAuthSession()).pipe(
      switchMap((auth: any) => {
        const { tokens } = auth;
        let jwt = tokens?.accessToken?.toString();
        if (!jwt) {
          return next.handle(request);
        }
        const withAuthRequest = request.clone({
          setHeaders: {
            Authorization: `${environment.providers.api.auth.type} ${jwt}`,
          },
        });
        const tk = localStorage.getItem('_tk');
        const isSwitchUser = this.cookieService.check('_switchUser');
        if (tk) {
          if (tk !== jwt && !isSwitchUser) {
            this.http.post('/users/logout', { expired: true }).subscribe(
              (res) => {
                this.awsService.getUserInfo().subscribe(
                  (res) => {
                    this.userProfileService.setUserFeature(res.role.modules);
                    this.userProfileService.setUserProfile(res);
                    if (res.language) {
                      localStorage.setItem('userLang', res.language);
                    }
                  },
                  (err) => console.log(err),
                );
              },
              (err) => console.log(err),
            );
          }
        }
        localStorage.setItem('_tk', jwt);
        return next.handle(withAuthRequest);
      }),
    );
  }
}
